Namespace 'CustomerVisualMode.Filters.LastInterval.Converters'

class CustomerVisualMode.Filters.LastInterval.Converters.MinuteConverter
  constructor: ->
    @aMinuteInSeconds = moment.duration(1, 'minutes').asSeconds()

  toSeconds: (minute) ->
    {
      name: @_label(minute)
      interval: @_minutesInSeconds(minute)
    }

  canConvert: (seconds) ->
    (seconds % @aMinuteInSeconds) == 0

  getLabelFromSeconds: (seconds) ->
    @_label(moment.duration(seconds, 'seconds').asMinutes())

  _minutesInSeconds: (minute) ->
    moment.duration(minute, 'minutes').asSeconds()

  _label: (minute) ->
    I18n.t('customer_visual_mode.filters.date.last_interval.minute', count: minute)
